
<ng-container *transloco="let t; prefix: 'customers'">
  @if (selectedView !== 'map' || isDesktop) {
    <mat-chip-listbox
      class="chip-list chip-filters"
      [class.chip-list-map-desktop]="selectedView === 'map' && isDesktop"
      hideSingleSelectionIndicator="true"
      (change)="onStatusChipChange($event)">
      @for (chip of statusChips; track chip.status) {
        <mat-chip-option class="chip-item" [value]="chip.status">
          <div class="chip-option">
            <div class="chip-icon">
              <i [attr.class]="'fa-' + chip.iconVariant + ' ' + chip.icon"></i>
            </div>

            <div class="chip-label">
              <div class="chip-label-primary title-small">
                {{ t(chip.labelKey) }}

                @if(!isMobile){
                  <span class="button-badge title-small"> {{ chip.countProp }} </span>
                }
              </div>

              <div class="chip-label-secondary">
                @if(isMobile){
                  <span class="button-badge title-small"> {{ chip.countProp }} </span>
                }

                @if(chip.amount !== undefined){
                  <div class="title-small">{{ chip.amount | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}</div>
                }
              </div>
            </div>
          </div>
        </mat-chip-option>
      }
    </mat-chip-listbox>
  }

  <form [formGroup]="filtersForm" class="form">
    <div class="searchbar-row">
      <mat-form-field appearance="outline" class="searchbar">
        <!-- <i matSuffix class="fa-regular fa-magnifying-glass icon-suffix"></i> -->
        <input matInput [placeholder]="t('search')" formControlName="searchText">
      </mat-form-field>

      @if (!isMobile) {
        <button
          matButton
          type="button"
          class="filter-trigger-button searchbar-filter-button"
          [attr.aria-label]="'customers.ui.mostraONascondiFiltri' | transloco"
          (click)="onFilterButtonClick()">
          <i class="fa-regular fa-filter"></i>
          <span class="label-large">{{ 'customers.ui.filtri' | transloco }}</span>
    </button>
      }
    </div>

    @if (!isMobile && filtersOpen && selectedView !== 'map') {
      <mat-card class="filters-card">
        <mat-card-content class="filters-card-content">
          <!-- Come si deve chiamare / Cosa deve esserci ?-->
          <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
            <mat-label>{{ t('filters.city') }}</mat-label>
            <input matInput formControlName="localita" [matAutocomplete]="autoLocalita" [placeholder]="'customers.ui.tutte' | transloco">
            <span matSuffix class="autocomplete-suffix">
              @if (filtersForm.get('localita')?.value) {
                <button
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="'customers.ui.svuotaLocalita' | transloco"
                  class="clear-suffix-button round-icon-button"
                  (click)="clearFilterField('localita')">
                  <i class="fa-regular fa-xmark"></i>
                </button>
              } @else {
                <i class="fa-regular fa-chevron-down icon-suffix"></i>
              }
            </span>
            <mat-autocomplete #autoLocalita="matAutocomplete">
              @for (opt of filteredLocalita | async; track opt) {
                <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
            <mat-label>{{ t('filters.zoneType') }}</mat-label>
            <input matInput formControlName="tipoZona" [matAutocomplete]="autoTipoZona" [placeholder]="'customers.ui.tutti' | transloco">
            <span matSuffix class="autocomplete-suffix">
              @if (filtersForm.get('tipoZona')?.value) {
                <button
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="'customers.ui.svuotaTipoZona' | transloco"
                  class="clear-suffix-button round-icon-button"
                  (click)="clearFilterField('tipoZona')">
                  <i class="fa-regular fa-xmark"></i>
                </button>
              } @else {
                <i class="fa-regular fa-chevron-down icon-suffix"></i>
              }
            </span>
            <mat-autocomplete #autoTipoZona="matAutocomplete" (optionSelected)="onTipoZonaSelected($event.option.value)">
              @for (opt of filteredTipoZona | async; track opt.id) {
                <mat-option [value]="opt">{{ opt.descrizione }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
            <mat-label>{{ t('filters.zone') }}</mat-label>
            <input matInput formControlName="zona" [matAutocomplete]="autoZona" [placeholder]="'customers.ui.zona' | transloco">
            <span matSuffix class="autocomplete-suffix">
              @if (filtersForm.get('zona')?.value) {
                <button
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="'customers.ui.svuotaZona' | transloco"
                  class="clear-suffix-button round-icon-button"
                  (click)="clearFilterField('zona')">
                  <i class="fa-regular fa-xmark"></i>
                </button>
              } @else {
                <i class="fa-regular fa-chevron-down icon-suffix"></i>
              }
            </span>
            <mat-autocomplete #autoZona="matAutocomplete" (optionSelected)="onZonaSelected($event.option.value)">
              @for (opt of filteredZona | async; track opt) {
                <mat-option [value]="opt">{{ opt.nome }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
            <mat-label>{{ t('filters.lastDate') }}</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dataUltimaFattura" [placeholder]="'customers.ui.datePlaceholder' | transloco">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          @if (agenteOptions.length) {
            <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
              <mat-label>{{ t('filters.agent') }}</mat-label>
              <input matInput formControlName="agente" [matAutocomplete]="autoAgente" [placeholder]="'customers.ui.tutti' | transloco">
              <span matSuffix class="autocomplete-suffix">
                @if (filtersForm.get('agente')?.value) {
                  <button
                    mat-icon-button
                    type="button"
                    [attr.aria-label]="'customers.ui.svuotaAgente' | transloco"
                    class="clear-suffix-button round-icon-button"
                    (click)="clearFilterField('agente')">
                    <i class="fa-regular fa-xmark"></i>
                  </button>
                } @else {
                  <i class="fa-regular fa-chevron-down icon-suffix"></i>
                }
              </span>
              <mat-autocomplete #autoAgente="matAutocomplete" (optionSelected)="onAgenteSelected($event.option.value)">
                @for (opt of filteredAgente | async; track opt.value) {
                  <mat-option [value]="opt">{{ opt.label }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }

          @if (ispettoreOptions.length) {
            <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
              <mat-label>{{ t('filters.inspector') }}</mat-label>
              <input matInput formControlName="ispettore" [matAutocomplete]="autoIspettore" [placeholder]="'customers.ui.tutti' | transloco">
              <span matSuffix class="autocomplete-suffix">
                @if (filtersForm.get('ispettore')?.value) {
                  <button
                    mat-icon-button
                    type="button"
                    [attr.aria-label]="'customers.ui.svuotaIspettore' | transloco"
                    class="clear-suffix-button round-icon-button"
                    (click)="clearFilterField('ispettore')">
                    <i class="fa-regular fa-xmark"></i>
                  </button>
                } @else {
                  <i class="fa-regular fa-chevron-down icon-suffix"></i>
                }
              </span>
              <mat-autocomplete #autoIspettore="matAutocomplete" (optionSelected)="onIspettoreSelected($event.option.value)">
                @for (opt of filteredIspettore | async; track opt.value) {
                  <mat-option [value]="opt">{{ opt.label }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }

          <mat-checkbox class="cliente-nuovo" formControlName="newCustomer">
            {{ t('filters.newCustomer') }}
          </mat-checkbox>
        </mat-card-content>

        <mat-card-actions align="end">
          <button matButton type="button" (click)="resetFilters()">{{ t('buttons.reset') }}</button>
          <button matButton="filled" type="button" (click)="applyFilters()">{{ t('buttons.apply') }}</button>
        </mat-card-actions>
      </mat-card>
    }

    <div class="view-bar">
      <div class="view-bar-main">
        <mat-button-toggle-group
          [value]="selectedView"
          (change)="onViewChange($event.value)"
          class="toggle"
          hideSingleSelectionIndicator="true">
          @for (options of viewOptions; track options.value) {
            <mat-button-toggle [value]="options.value">
              <i [attr.class]="'fa-' + options.iconVariant + ' ' + options.icon"></i> {{ t(options.labelKey) }}
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>

      <div class="view-bar-actions">
        @if (!isMobile && selectedView === 'card') {
          <button
            matButton
            type="button"
            class="filter-trigger-button"
            [attr.aria-label]="'customers.ui.ordinamento' | transloco"
            (click)="openSortDialog()">
            <i class="fa-regular fa-arrow-down-arrow-up"></i>
            <span class="label-large">{{ 'customers.ui.ordina' | transloco }}</span>
          </button>
        }
        @if (isMobile && selectedView === 'card') {
          <button
            mat-icon-button
            type="button"
            class="round-icon-button view-bar-filter-button"
            [attr.aria-label]="'customers.ui.ordinamento' | transloco"
            (click)="openSortDialog()">
            <i class="fa-regular fa-arrow-down-arrow-up"></i>
          </button>
        }
      </div>
    </div>

    @if (!isMobile && filtersOpen && selectedView === 'map') {
      <mat-card class="filters-card">
        <mat-card-content class="filters-card-content">
          <!-- Come si deve chiamare / Cosa deve esserci ?-->
          <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
            <mat-label>{{ t('filters.city') }}</mat-label>
            <input matInput formControlName="localita" [matAutocomplete]="autoLocalita" [placeholder]="'customers.ui.tutte' | transloco">
            <span matSuffix class="autocomplete-suffix">
              @if (filtersForm.get('localita')?.value) {
                <button
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="'customers.ui.svuotaLocalita2' | transloco"
                  class="clear-suffix-button round-icon-button"
                  (click)="clearFilterField('localita')">
                  <i class="fa-regular fa-xmark"></i>
                </button>
              } @else {
                <i class="fa-regular fa-chevron-down icon-suffix"></i>
              }
            </span>
            <mat-autocomplete #autoLocalita="matAutocomplete">
              @for (opt of filteredLocalita | async; track opt) {
                <mat-option [value]="opt">{{ opt }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
            <mat-label>{{ t('filters.zoneType') }}</mat-label>
            <input matInput formControlName="tipoZona" [matAutocomplete]="autoTipoZona" [placeholder]="'customers.ui.tutti' | transloco">
            <span matSuffix class="autocomplete-suffix">
              @if (filtersForm.get('tipoZona')?.value) {
                <button
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="'customers.ui.svuotaTipoZona' | transloco"
                  class="clear-suffix-button round-icon-button"
                  (click)="clearFilterField('tipoZona')">
                  <i class="fa-regular fa-xmark"></i>
                </button>
              } @else {
                <i class="fa-regular fa-chevron-down icon-suffix"></i>
              }
            </span>
            <mat-autocomplete #autoTipoZona="matAutocomplete" (optionSelected)="onTipoZonaSelected($event.option.value)">
              @for (opt of filteredTipoZona | async; track opt.id) {
                <mat-option [value]="opt">{{ opt.descrizione }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
            <mat-label>{{ t('filters.zone') }}</mat-label>
            <input matInput formControlName="zona" [matAutocomplete]="autoZona" [placeholder]="'customers.ui.zona' | transloco">
            <span matSuffix class="autocomplete-suffix">
              @if (filtersForm.get('zona')?.value) {
                <button
                  mat-icon-button
                  type="button"
                  [attr.aria-label]="'customers.ui.svuotaZona' | transloco"
                  class="clear-suffix-button round-icon-button"
                  (click)="clearFilterField('zona')">
                  <i class="fa-regular fa-xmark"></i>
                </button>
              } @else {
                <i class="fa-regular fa-chevron-down icon-suffix"></i>
              }
            </span>
            <mat-autocomplete #autoZona="matAutocomplete" (optionSelected)="onZonaSelected($event.option.value)">
              @for (opt of filteredZona | async; track opt) {
                <mat-option [value]="opt">{{ opt.nome }}</mat-option>
              }
            </mat-autocomplete>
          </mat-form-field>

          <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
            <mat-label>{{ t('filters.lastDate') }}</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="dataUltimaFattura" [placeholder]="'customers.ui.datePlaceholder' | transloco">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>

          @if (agenteOptions.length) {
            <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
              <mat-label>{{ t('filters.agent') }}</mat-label>
              <input matInput formControlName="agente" [matAutocomplete]="autoAgente" [placeholder]="'customers.ui.tutti' | transloco">
              <span matSuffix class="autocomplete-suffix">
                @if (filtersForm.get('agente')?.value) {
                  <button
                    mat-icon-button
                    type="button"
                    [attr.aria-label]="'customers.ui.svuotaAgente' | transloco"
                    class="clear-suffix-button round-icon-button"
                    (click)="clearFilterField('agente')">
                    <i class="fa-regular fa-xmark"></i>
                  </button>
                } @else {
                  <i class="fa-regular fa-chevron-down icon-suffix"></i>
                }
              </span>
              <mat-autocomplete #autoAgente="matAutocomplete" (optionSelected)="onAgenteSelected($event.option.value)">
                @for (opt of filteredAgente | async; track opt.value) {
                  <mat-option [value]="opt">{{ opt.label }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }

          @if (ispettoreOptions.length) {
            <mat-form-field appearance="outline" class="filter-field" subscriptSizing="dynamic">
              <mat-label>{{ t('filters.inspector') }}</mat-label>
              <input matInput formControlName="ispettore" [matAutocomplete]="autoIspettore" [placeholder]="'customers.ui.tutti' | transloco">
              <span matSuffix class="autocomplete-suffix">
                @if (filtersForm.get('ispettore')?.value) {
                  <button
                    mat-icon-button
                    type="button"
                    [attr.aria-label]="'customers.ui.svuotaIspettore' | transloco"
                    class="clear-suffix-button round-icon-button"
                    (click)="clearFilterField('ispettore')">
                    <i class="fa-regular fa-xmark"></i>
                  </button>
                } @else {
                  <i class="fa-regular fa-chevron-down icon-suffix"></i>
                }
              </span>
              <mat-autocomplete #autoIspettore="matAutocomplete" (optionSelected)="onIspettoreSelected($event.option.value)">
                @for (opt of filteredIspettore | async; track opt.value) {
                  <mat-option [value]="opt">{{ opt.label }}</mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          }

          <mat-checkbox class="cliente-nuovo" formControlName="newCustomer">
            {{ t('filters.newCustomer') }}
          </mat-checkbox>
        </mat-card-content>

        <mat-card-actions align="end">
          <button matButton type="button" (click)="resetFilters()">{{ t('buttons.reset') }}</button>
          <button matButton="filled" type="button" (click)="applyFilters()">{{ t('buttons.apply') }}</button>
        </mat-card-actions>
      </mat-card>
    }

    @if (customersLoading) {
      <ui-loading-spinner></ui-loading-spinner>
    } @else {
      @switch (selectedView) {
        @case ('table') {
        <ui-table-view
          class="table-view"
          [columnsInfo]="columnsInfo"
          [data]="customers"
          [sortColumns]="currentSortColumns"
          (sortChange)="onSortChange($event)"
          (rowClicked)="goToDetail($event)"
          (reloadData)="loadCustomers()">
        </ui-table-view>
        }
        @case ('card') {
        <!-- Invece di passare per la list page prendo i dati dal componente direttamente
        TODO: Verificare in autorizzazione-ordini se funziona uguale -->
        @if (customers.length === 0) {
          <span class="title-small empty-message-container">{{ 'customers.ui.nessunRisultatoPresente' | transloco }}</span>
        } @else {
        <div class="card-list">
          @for (item of customers; track item.ragioneSociale) {
            <mat-card class="client-card" appearance="outlined" (click)="goToDetail(item)">
              <mat-card-content>
                <div class="client-card-header">
                  <div class="client-card-main">
                    <span class="client-card-title body-medium">{{ item.ragioneSociale }}</span>
                    <span class="client-card-subtitle body-small">{{ item.nomeZona }} - {{ item.nomeAgente }}</span>
                  </div>
                  <cus-icon-alert [alert]="item.alert"></cus-icon-alert>
                </div>

                <mat-divider></mat-divider>

                <div class="client-card-details">
                  <div class="client-card-detail-item">
                    <span class="client-card-detail-label body-medium">{{ t('card.exposure') }}</span>
                    <span class="client-card-detail-value body-medium" [ngClass]="getCustomerStatusClass(item.esposizioneStato)">{{ item.esposizione | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}</span>
                  </div>
                  <div class="client-card-detail-item">
                    <span class="client-card-detail-label body-medium">{{ t('card.revenue') }}</span>
                    <span class="client-card-detail-value body-medium">{{ item.fatturatoRolling12m | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}</span>
                  </div>
                  <div class="client-card-detail-item">
                    <span class="client-card-detail-label body-medium">{{ t('card.lastInvoice') }}</span>
                    <span class="client-card-detail-value body-medium">{{ item.dataUltimaFattura ? (item.dataUltimaFattura | date:'dd/MM/yyyy') : '-' }}</span>
                  </div>
                  <div class="client-card-detail-item">
                    <span class="client-card-detail-label body-medium">{{ t('card.city') }}</span>
                    <span class="client-card-detail-value body-medium">{{ item.localita ? item.localita : '-' }}</span>
                  </div>
                  <div class="client-card-detail-item">
                    <span class="client-card-detail-label body-medium">{{ t('card.creditLimit') }}</span>
                    <span class="client-card-detail-value body-medium" [ngClass]="getCustomerStatusClass(item.affidamentoStato)">{{ item.affidamento | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}</span>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          }
        </div>
        }
        }
        @case ('map') {
        <div class="map-wrapper" [class.advisor-open]="mapAdvisorOpen">
          <div class="map-view">
            @if (!isDesktop) {
              <div class="map-overlay">
                <mat-chip-listbox class="chip-list chip-filters map-overlay-chips" hideSingleSelectionIndicator="true" (change)="onStatusChipChange($event)">
                  @for (chip of statusChips; track chip.status) {
                    <mat-chip-option class="chip-item map-chip-item" [value]="chip.status">
                      <div class="chip-option map-chip-option">
                        <div class="chip-icon map-chip-icon">
                          <i [attr.class]="'fa-' + chip.iconVariant + ' ' + chip.icon"></i>
                        </div>

                        <div class="chip-label map-chip-label">
                          <div class="chip-label-primary title-small">
                            {{ t(chip.labelKey) }}
                          </div>
                        </div>
                      </div>
                    </mat-chip-option>
                  }
                </mat-chip-listbox>
              </div>
            }

            @if (isMobile) {
              <button class="toggle-map-advisor-mobile" (click)="toggleMapAdvisor()">
                <i class="fa-regular fa-list"></i>
                <span>{{ 'customers.ui.elenco' | transloco }}</span>
              </button>
            }

            <!-- Info: Per far funzionare i marker serve dare un ID alla mappa -->
            @if (!mapMarkersLoaded) {
              <ui-loading-spinner></ui-loading-spinner>
            } @else {
            <google-map
              class="map-surface"
              mapId="mapProva"
              height="100%"
              width="100%"
              [center]="center"
              [zoom]="zoom"
              [options]="mapOptions">
                @for (p of zonePolygons; track $index) {
                  <map-polygon [paths]="p.paths" [options]="p.options" />
                }
                <map-marker-clusterer [algorithm]="clusterAlgorithm">
                  @for (m of mapMarkers; track m.idPrimoCliente) {
                    <map-advanced-marker
                      [position]="m.mapPosition"
                      [content]="getMarkerContent(m)"
                      #marker="mapAdvancedMarker"
                      (markerInitialized)="onMarkerInitialized($event)"
                      (mapClick)="openInfoWindow(marker, m)" />
                <!-- Info: Darà come warning di usare gmpClick che però su Angular
                     non è ancora stato implementato -->
                  }
                </map-marker-clusterer>
                <map-info-window>
                  @if (selectedMarker) {
                    <div class="map-info-card" (click)="goToDetail(selectedMarker)">
                      <div class="client-card-header">
                        <div class="client-card-main">
                          <span class="client-card-title body-medium">{{ selectedMarker.ragioneSociale }}</span>
                          <span class="client-card-subtitle body-small">{{ selectedMarker.nomeZona }} - {{ selectedMarker.nomeAgente }}</span>
                        </div>
                        <cus-icon-alert [alert]="selectedMarker.alert"></cus-icon-alert>
                      </div>
                      <mat-divider></mat-divider>
                      <div class="client-card-details">
                        <div class="client-card-detail-item">
                          <span class="client-card-detail-label body-medium">{{ t('card.exposure') }}</span>
                          <span class="client-card-detail-value body-medium" [ngClass]="getCustomerStatusClass(selectedMarker.esposizioneStato)">{{ selectedMarker.esposizione | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}</span>
                        </div>
                        <div class="client-card-detail-item">
                          <span class="client-card-detail-label body-medium">{{ t('card.revenue') }}</span>
                          <span class="client-card-detail-value body-medium">{{ selectedMarker.fatturatoRolling12m | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}</span>
                        </div>
                        <div class="client-card-detail-item">
                          <span class="client-card-detail-label body-medium">{{ t('card.lastInvoice') }}</span>
                          <span class="client-card-detail-value body-medium">{{ selectedMarker.dataUltimaFattura ? (selectedMarker.dataUltimaFattura | date:'dd/MM/yyyy') : '-' }}</span>
                        </div>
                        <div class="client-card-detail-item">
                          <span class="client-card-detail-label body-medium">{{ t('card.city') }}</span>
                          <span class="client-card-detail-value body-medium">{{ selectedMarker.localita ? selectedMarker.localita : '-' }}</span>
                        </div>
                        <div class="client-card-detail-item">
                          <span class="client-card-detail-label body-medium">{{ t('card.creditLimit') }}</span>
                          <span class="client-card-detail-value body-medium" [ngClass]="getCustomerStatusClass(selectedMarker.affidamentoStato)">{{ selectedMarker.affidamento | translocoCurrency: 'symbol' : { useGrouping: true, minimumFractionDigits: 2, maximumFractionDigits: 2 } : 'EUR' }}</span>
                        </div>
                      </div>
                    </div>
                  }
                </map-info-window>
            </google-map>
            }
          </div>

          @if (!isMobile) {
            <aside class="map-advisor-sidebar">
              <button class="toggle-map-advisor" (click)="toggleMapAdvisor()">
                <i [attr.class]="mapAdvisorOpen ? 'fa-regular fa-chevron-right' : 'fa-regular fa-chevron-left'"></i>
              </button>
              <div class="map-advisor-sidebar-content">
                <div class="map-advisor" (scroll)="onAdvisorScroll($event)">
                  @for (customer of advisorCustomers; track customer.idPrimoCliente) {
                    <div class="map-advisor-item" (click)="focusOnCustomer(customer)">
                      <span class="map-advisor-name body-medium">{{ customer.ragioneSociale }}</span>
                      <span class="map-advisor-sub body-small">{{ customer.localita }}</span>
                    </div>
                  }
                  @if (advisorLoading) {
                    <div class="map-advisor-loading">
                      <i class="fa-regular fa-spinner-third fa-spin"></i>
                    </div>
                  }
                </div>
              </div>
            </aside>
          }
        </div>
        }
      }
    }

    <!-- Paginator condiviso tra tutte le viste -->
    @if(selectedView != 'map' && !customersLoading){
      <mat-paginator
        class="paginator"
        [length]="totalItems"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        [pageSizeOptions]="[5, 10, 25]"
        [hidePageSize]="true"
        (page)="onPageChange($event)">
      </mat-paginator>
    }
  </form>

  <ng-template #advisorSheet>
    <div class="advisor-sheet-list" (scroll)="onAdvisorScroll($event)">
      @for (customer of advisorCustomers; track customer.idPrimoCliente) {
        <div class="map-advisor-item" (click)="focusOnCustomer(customer)">
          <span class="map-advisor-name body-medium">{{ customer.ragioneSociale }}</span>
          <span class="map-advisor-sub body-small">{{ customer.localita }}</span>
        </div>
      }
      @if (advisorLoading) {
        <div class="map-advisor-loading">
          <i class="fa-regular fa-spinner-third fa-spin"></i>
        </div>
      }
    </div>
  </ng-template>
</ng-container>
